const GiftType = {
    PHYSICAL: "PHYSICAL",
    PROMOTION_CARD: "PROMOTION_CARD",
};

export { GiftType };